
import { WHATSAPP_MESSAGES } from "./whatsappMessages";

/**
 * Generic function to send WhatsApp messages
 * @param {Object} options
 * @param {Object} options.invoice - Invoice or relevant data
 * @param {Object} options.userDetails - Logged-in owner/user details
 * @param {string} options.type - Type of message ("rentInvoiceReminder", etc.)
 * @param {Function} [options.showToast] - Optional callback for errors
 */
export const sendWhatsAppMessage = ({ invoice, userDetails, type, showToast }) => {
  const phone = invoice.tenant_contact || invoice.owner_contact;

  if (!phone) {
    showToast?.({ message: "No phone number available!", severity: "error" });
    return;
  }

  const formattedPhone = phone.replace(/\D/g, "");
  const templateFn = WHATSAPP_MESSAGES[type];

  if (!templateFn) {
    showToast?.({ message: "Invalid WhatsApp message type!", severity: "error" });
    return;
  }

  const message = templateFn(invoice, userDetails);
  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${formattedPhone}?text=${encodedMessage}`;
  window.open(whatsappUrl, "_blank");
};
